export default __webpack_public_path__ + "static/media/img_near.5daa7a62.svg";